import { convertSize } from "../../../lib/commonFunctions/convertSize";
import { compressString } from "../../../lib/commonFunctions/compressString";
import { red } from "@mui/material/colors";
import { Alert, Box, Button, IconButton, List, ListItem, Paper, Stack, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { CancelRounded, CloseRounded, DoneRounded, InsertDriveFileRounded } from "@mui/icons-material";
import ProgressRing from "../../common/progressRing";
import LoadingSpinner from "../../loading/loadingSpinner";
import { Link } from "react-router-dom";

const UploadingFiles = (props) => {

    const { files, setFiles, onAbort, onAbortAll, isUploading, uploadDone, generatedLink, pending, ...restProps } = props;
    const fileSize = (size) => convertSize(size);
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));

    const FileIcon = ({ percentage = 0, isCompleted, isAborted }) => {

        const progressRingStyles = {
            ...(!isAborted ? { color: "#64dd17" } : { color: red[500] }),
            width: 1,
            height: 1,
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
        }
        const iconWrapperStyles = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 55,
            height: 55,
            color: "#fff",
            ...(isCompleted ? {
                background: "#64dd17",
            } : { background: theme => theme.palette.primary.main }),
            borderRadius: "50%",
            boxShadow: 25,
        }

        return (
            <Box position="relative">
                <Box sx={iconWrapperStyles}>
                    {!isCompleted
                        ?
                        <InsertDriveFileRounded />
                        :
                        <DoneRounded />
                    }
                </Box>
                <ProgressRing
                    progress={percentage} radius={55} stroke={4}
                    sx={progressRingStyles}
                    circleProps={{ sx: { transformOrigin: '50% 0' } }} />
            </Box>
        )
    }

    return (
        <Paper sx={{ p: 2.5, height: 1 }} {...restProps}>
            <Typography fontSize=".9rem" fontWeight={600} textAlign="center">{`${files.length.toLocaleString('fa-IR')} فایل انتخاب شده`}</Typography>
            <List>
                {files.map((file, index) => (
                    <ListItem key={index} sx={{ justifyContent: "space-between" }}>
                        <Box display="flex" alignItems="center">
                            <FileIcon percentage={file.progress} isCompleted={file.isCompleted} isAborted={file.isAborted} />
                            <Typography ml={1} fontSize={{ xs: ".985rem" }}>{`${compressString(file.name, isMobile ? 12 : 24)} - ${fileSize(file.size)}`}</Typography>
                        </Box>
                        <Stack direction="row" alignItems="center">
                            {!file.isCompleted && !file.isAborted
                                ?
                                <>
                                    <Tooltip title="انصراف">
                                        <IconButton onClick={() => onAbort(file)} color="error">
                                            <CloseRounded />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="درصد پیشرفت" sx={{ display: { xs: "none", sm: "flex" } }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <LoadingSpinner />
                                            <Typography fontSize={{ xs: ".925rem" }} fontWeight={500}>{file?.progress ? file.progress.toLocaleString('fa-IR') + "%" : "۰٪"}</Typography>
                                        </Stack>
                                    </Tooltip>
                                </>
                                :
                                file.isAborted
                                    ?
                                    <Stack direction="row" alignItems="center" spacing={.5} >
                                        <CancelRounded fontSize="small" color="error" />
                                        <Typography fontSize={{ xs: ".85rem" }} color="error" whiteSpace="nowrap">لغو شده</Typography>
                                    </Stack>
                                    :
                                    <Stack direction="row" alignItems="center" spacing={.5} >
                                        <DoneRounded fontSize="small" color="success" />
                                        <Typography fontSize={{ xs: ".85rem" }} color="success" whiteSpace="nowrap">آپلود شده</Typography>
                                    </Stack>
                            }
                        </Stack>
                    </ListItem>
                ))}
            </List>
            {isUploading && (
                <Button onClick={onAbortAll} fullWidth variant="contained" color="error" sx={{ py: 1.5, mt: 2 }}>انصراف</Button>
            )}
            {pending && (
                <Box my={1} display="flex" alignItems="center">
                    <Typography mr={1}>در حال پردازش..</Typography>
                    <LoadingSpinner />
                </Box>
            )}
            {uploadDone && generatedLink
                ?
                <>
                    <Alert severity="success">
                        اشتراک گذاری شما با موفقیت انجام شد، کد اشتراک گذاری:
                        <Link to={`/share/${generatedLink}`}> {generatedLink}</Link>
                    </Alert>
                    <Button onClick={() => setFiles([])} fullWidth variant="contained" sx={{ py: 1.5, mt: 2 }}>بستن</Button>
                </>
                : null}
        </Paper>
    )
}
export default UploadingFiles;
